module.exports = __webpack_public_path__ + "img/清华大学.b7a7e85d.png";